// Energinets brandfarver: den eneste TS-kilde. Pixi (src/render/palette.ts) og inline SVG læser herfra,
// og src/ui/tokens.css har de samme værdier som CSS-variabler. test/design-tokens.test.ts holder dem ens.
// Rød kun til udfald, brud og mørkeure. Regler og opskrifter: design/DESIGN.md.

export const BRAND = {
  green: '#00a58d',
  greenDark: '#00847c', // kontrastgrøn: hvid tekst på knapper
  greenDeep: '#008a8b',
  greenLight: '#9fcd91',
  yellow: '#ffd424',
  orange: '#f8ae3c',
  red: '#ce3e33',
  turquoise: '#00a6bc',
  blueLight: '#c2e4f0',
  petrol: '#09505d',
  ink: '#293a4c',
  paper: '#f5faf9',
  white: '#ffffff',
} as const;

export type BrandColor = keyof typeof BRAND;

/** CSS-variablens navn for hver brandfarve i tokens.css. */
export const BRAND_VAR: Record<BrandColor, string> = {
  green: '--green',
  greenDark: '--green-dark',
  greenDeep: '--green-deep',
  greenLight: '--green-light',
  yellow: '--yellow',
  orange: '--orange',
  red: '--red',
  turquoise: '--turquoise',
  blueLight: '--blue-light',
  petrol: '--petrol',
  ink: '--ink',
  paper: '--paper',
  white: '--white',
};

/** '#00a58d' til 0x00a58d, som Pixi vil have. */
export function hexToNum(hex: string): number {
  return parseInt(hex.slice(1), 16);
}
